import pLimit from "p-limit";
import { FileUploadError } from "./FileUploadError.js";
import { GenerateUploadUrlMutationBuilder } from "./GenerateUploadUrlMutationBuilder.js";
import { readFileAsArrayBuffer } from "../../utils/readFileAsArrayBuffer.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class S3FileUploader {
  constructor(options = {}) {
    this.options = options;
    __publicField(this, "uploadState");
    __publicField(this, "generateNewAlias", (() => {
      let alias = 1;
      return () => alias++;
    })());
    this.uploadState = /* @__PURE__ */ new WeakMap();
  }
  static formatFullAlias(alias) {
    return `file${alias}`;
  }
  async upload(files, options) {
    const parameters = {};
    for (const [file, metadata] of files) {
      if (this.uploadState.has(file)) {
        const uploadState = this.uploadState.get(file);
        uploadState.request?.abort();
      }
      const alias = this.generateNewAlias();
      this.uploadState.set(file, {
        alias
      });
      const uploadOptions = this.options.getUploadOptions?.(file);
      parameters[S3FileUploader.formatFullAlias(alias)] = {
        contentType: uploadOptions?.fileType ?? file.type,
        prefix: uploadOptions?.filePrefix,
        suffix: uploadOptions?.fileSuffix,
        size: uploadOptions?.fileSize,
        extension: uploadOptions?.fileExtension,
        fileName: uploadOptions?.fileName,
        expiration: uploadOptions?.fileExpiration,
        acl: uploadOptions?.fileAcl
      };
      metadata.abortSignal.addEventListener("abort", () => {
        this.uploadState.get(file)?.request?.abort();
      });
    }
    const mutation = GenerateUploadUrlMutationBuilder.buildQuery(parameters);
    try {
      const response = await options.contentApiClient.sendRequest(mutation);
      const responseData = response.data;
      const limit = pLimit(this.options.concurrency ?? 5);
      const promises = [];
      for (const [file] of files) {
        promises.push(limit(() => this.uploadSingleFile(file, responseData, options)));
      }
      await Promise.all(promises);
    } catch (error) {
      if (error instanceof FileUploadError) {
        const fileUploadError = error;
        options.onError(Array.from(files).map(([file]) => [file, fileUploadError]));
      } else {
        throw error;
      }
    }
  }
  uploadSingleFile(file, responseData, { onProgress, onError, onSuccess }) {
    return new Promise(async (resolve, reject) => {
      const fileState = this.uploadState.get(file);
      const datumBody = responseData[S3FileUploader.formatFullAlias(fileState.alias)];
      const uploadRequestBody = await readFileAsArrayBuffer(file);
      const xhr = new XMLHttpRequest();
      fileState.request = xhr;
      xhr.open(datumBody.method, datumBody.url);
      for (const header of datumBody.headers) {
        xhr.setRequestHeader(header.key, header.value);
      }
      xhr.addEventListener("load", () => {
        const successMetadata = {
          fileUrl: datumBody.publicUrl
        };
        onSuccess([[file, successMetadata]]);
        resolve();
      });
      xhr.addEventListener("error", (e) => {
        onError([file]);
        reject(e);
      });
      xhr.upload?.addEventListener("progress", (e) => {
        onProgress([
          [
            file,
            {
              progress: e.loaded / e.total
            }
          ]
        ]);
      });
      xhr.send(uploadRequestBody);
    });
  }
}
export {
  S3FileUploader
};
//# sourceMappingURL=S3FileUploader.js.map
